var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right_Arrow",
    "data-name": "Right Arrow",
    transform: "translate(-101 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10699",
    "data-name": "Rectangle 10699",
    width: 16,
    height: 16,
    transform: "translate(101 3)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M1306.56,292.471l3.48-3.471-3.48-3.471",
    transform: "translate(-1199 -278.029)",
    fill: "none",
    stroke: "#0062ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/Arrowright.46966444.svg";
export { ForwardRef as ReactComponent };